module.exports = __webpack_public_path__ + "static/bus_interprovincial-ab5c8e209de20fb955d0958ec9204a09.jpg";